import React from 'react'
import Field from '../../common/FormField'

import styles from '../Form.module.css'

export default ({ data, disabled, error, onChangeFactory }) => {
  const isLoose = data.setting === 'loose' || data.setting === 'gemstone'
  let mountTypeTitle = null
  if (!isLoose) {
    mountTypeTitle =
      data.mountType === 'center-stone'
        ? <h4>Center Stone:</h4>
        : <h4>Multiple Stones:</h4>
  }
  return (
    <fieldset>
      <Field name="Discount Sale or Markup?">
        <div className="row">
          <div className="col col-2">
            <label className="radio">
              <input
                type="radio"
                name="saleMarkupGroup"
                value="none"
                checked={data.saleMarkupType === 'none' || !data.saleMarkupType}
                onChange={onChangeFactory('saleMarkupType')}
                disabled={disabled}
              />
              <i />None
            </label>
          </div>
          <div className="col col-2">
            <label className="radio">
              <input
                type="radio"
                name="saleMarkupGroup"
                value="sale"
                checked={data.saleMarkupType === 'sale'}
                onChange={onChangeFactory('saleMarkupType')}
                disabled={disabled}
              />
              <i />Sale
            </label>
          </div>
          <div className="col col-2">
            <label className="radio">
              <input
                type="radio"
                name="saleMarkupGroup"
                value="markup"
                checked={data.saleMarkupType === 'markup'}
                onChange={onChangeFactory('saleMarkupType')}
                disabled={disabled}
              />
              <i />Markup
            </label>
          </div>
        </div>
      </Field>
      {data.saleMarkupType === 'markup' &&
        <Field type="input" name="Markup %" error={error.markup}>
          <input
            type="text"
            placeholder="Enter markup % (e.g. 20 for 20%)"
            value={data.markup}
            onChange={onChangeFactory('markup')}
            disabled={disabled}
          />
          <div className="note">
            This percentage will mark up the retail price you entered earlier.
            We will only show the marked up price (price + price × markup / 100).
          </div>
        </Field>}
      {data.saleMarkupType === 'sale' &&
        <Field type="input" name="Sale Price" error={error.salePrice}>
          <input
            type="text"
            placeholder="Enter sale price"
            value={data.salePrice}
            onChange={onChangeFactory('salePrice')}
            disabled={disabled}
          />
          <div className="note">
            We will automatically show the sale percentage (%) from retail price
            you entered earlier.
          </div>
        </Field>}
      <Field type="input" name="Custom Title">
        <input
          type="text"
          placeholder="Enter the title of the item"
          value={data.customTitle}
          onChange={onChangeFactory('customTitle')}
          maxLength={50}
          disabled={disabled}
        />
        <div className="note">Maximum 50 characters.</div>
      </Field>
      <Field type="input" name="Internal ID">
        <input
          type="text"
          placeholder="Enter internal ID"
          value={data.internalId}
          onChange={onChangeFactory('internalId')}
          disabled={disabled}
        />
        <div className="note">Suitable for internal inventory tracking.</div>
      </Field>
      {mountTypeTitle}
      <Field type="input" name="Certificate Number" error={error.certNum}>
        <input
          type="text"
          placeholder="Enter certificate number"
          value={data.certNum}
          onChange={onChangeFactory('certNum')}
          disabled={disabled}
        />
      </Field>
      <Field type="input" name="Link to Certificate">
        <input
          type="text"
          placeholder="Enter link to certificate URL (i.e. http://website.com/certificate.html)"
          value={data.linkToCert}
          onChange={onChangeFactory('linkToCert')}
          disabled={disabled}
        />
      </Field>
      <Field type="select" name="Fluorescence">
        <select
          value={data.fluorescence}
          onChange={onChangeFactory('fluorescence')}
          disabled={disabled}
        >
          <option value="">Select fluorescence</option>
          <option value="-" disabled>
            -----
          </option>
          <option value="non">NON</option>
          <option value="faint">FAINT</option>
          <option value="med">MED</option>
          <option value="strong">STRONG</option>
          <option value="very-strong">VERY STRONG</option>
        </select>
        <i />
      </Field>
      <Field type="select" name="Enhancement / Treatment">
        <select
          value={data.enhancement}
          onChange={onChangeFactory('enhancement')}
          disabled={disabled}
        >
          <option value="">Select enhancement</option>
          <option value="-" disabled>
            -----
          </option>
          <option value="hpht">High Pressure High Temperature</option>
          <option value="laser-drilling">Laser Drilling</option>
          <option value="fracture-filling">Fracture Fillings</option>
        </select>
        <i />
      </Field>
      <Field type="select" name="Symmetry">
        <select
          value={data.symmetry}
          onChange={onChangeFactory('symmetry')}
          disabled={disabled}
        >
          <option value="">Select symmetry</option>
          <option value="-" disabled>
            -----
          </option>
          <option value="excellent">Excellent</option>
          <option value="very-good">Very Good</option>
          <option value="good">Good</option>
          <option value="fair">Fair</option>
          <option value="poor">Poor</option>
        </select>
        <i />
      </Field>
      <Field type="select" name="Polish">
        <select
          value={data.polish}
          onChange={onChangeFactory('polish')}
          disabled={disabled}
        >
          <option value="">Select polish</option>
          <option value="-" disabled>
            -----
          </option>
          <option value="excellent">Excellent</option>
          <option value="very-good">Very Good</option>
          <option value="good">Good</option>
          <option value="fair">Fair</option>
          <option value="poor">Poor</option>
        </select>
        <i />
      </Field>
      <Field type="input" name="Laser Inscriptions">
        <input
          type="text"
          placeholder="Enter any inscription details (i.e. GIA appraisal number)"
          value={data.laserInscription}
          onChange={onChangeFactory('laserInscription')}
          disabled={disabled}
        />
      </Field>
      <Field type="checkbox">
        <input
          type="checkbox"
          checked={data.synthetic}
          onChange={onChangeFactory('synthetic')}
          disabled={disabled}
        />
        <i />Synthetic
      </Field>
      <Field
        className={styles.proportionsContainer}
        name="Proportions (Length x Width x Depth)"
        error={error.proportions}
      >
        <label className={`input ${error.proportions ? 'state-error' : ''}`}>
          <input
            type="text"
            placeholder="Length"
            value={data.propLength}
            onChange={onChangeFactory('propLength')}
            disabled={disabled}
          />
        </label>
        <span className={styles.proportionsSep}>X</span>
        <label className={`input ${error.proportions ? 'state-error' : ''}`}>
          <input
            type="text"
            placeholder="Width"
            value={data.propWidth}
            onChange={onChangeFactory('propWidth')}
            disabled={disabled}
          />
        </label>
        <span className={styles.proportionsSep}>X</span>
        <label className={`input ${error.proportions ? 'state-error' : ''}`}>
          <input
            type="text"
            placeholder="Depth"
            value={data.propDepth}
            onChange={onChangeFactory('propDepth')}
            disabled={disabled}
          />
        </label>
        <span className={styles.proportionsSep}>(mm)</span>
      </Field>
      {!isLoose &&
        data.mountType === 'center-stone' &&
        <div>
          <h4>Side Stones:</h4>
          <Field
            type="input"
            name="Total Side Carat Weight"
            error={error.totalWeightCarat}
          >
            <input
              type="text"
              placeholder="Enter total side carats (i.e. 0.75)"
              value={data.totalWeightCarat}
              onChange={onChangeFactory('totalWeightCarat')}
              disabled={disabled}
            />
          </Field>
        </div>}
    </fieldset>
  )
}
